<template>
  <div id="app">
    <Nav/>
    <transition name="page">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
export default {
  components: {
    Nav
  }
};
</script>


<style lang="scss">
:root {
  --prim-c: #cc2c18;
  --acc-c: #ff6108;
  --border: unset;
}

* {
  box-sizing: border-box;
  margin: 0;
}

ul,
li {
  list-style-type: none;
  padding: 0;
}

h1,
h2,
h3,
p,
span,
a,
body {
  font-family: "work sans", sans-serif;
  line-height: 1.2;
}

h1,
h2,
h3 {
  font-weight: 700;
  cursor: default;
}

p {
  font-weight: 300;
  line-height: 1.5;
  cursor: default;
}

body {
  font-size: 16px;
  color: #000;
}

h1 {
  font-size: 42px;
}

h2 {
  font-size: 32px;
}

h3 {
  font-size: 22px;
}

a {
  text-decoration: none;
  color: inherit;
  opacity: 0.8;
  transition: opacity 0.25s ease;
  color: var(--prim-c);
  font-weight:500;
}

a:hover {
  opacity: 1;
}

.default-button {
  position: relative;
  display: inline-block;
  background-color: transparent;
  margin: 20px 0;
  z-index: 1;
  transition: 0.25s ease;
  border: 1px solid var(--prim-c);
  a {
    position: relative;
    opacity: 1;
    z-index: 2;
    .button-inner {
      padding: 10px 40px 10px 10px;
      transition: color 0.1s ease;
      transition-delay: 0s;
    }
  }
  &:after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    background-color: var(--prim-c);
    background-image: url("./assets/img/chev-r.svg");
    background-repeat: no-repeat;
    background-position: 10px center;
    background-size: 12px;
    width: 30px;
    height: 100%;
    transition: width 0.2s ease;
    z-index: -1;
  }
  &:hover {
    color: #000;
    a {
      .button-inner {
        padding: 10px 10px 10px 40px;
        color: #000;
        transition: color 0.2s ease;
        transition-delay: 0.2s;
      }
    }
  }
  &:hover:after {
    width: 100%;
  }
}

#app {
  position: relative;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%;
  width: 100%;
  .page {
    position: fixed;
    height: 100%;
    width: 100%;
    padding: 0 0 0 20%;
    z-index: 5;
    opacity:1;
    transform: translateY(0);
    @media (max-width:1024px) {
      padding:0;
      position: relative;
    }
  }
  .page-leave-active {
    transition:.5s
  }
  .page-enter,.page-leave-to {
    transform: translateY(-40px);
    opacity:0;
  }
  .page-enter-active {
    transition: .5s ease;
    transition-delay: .5s;
  }
}

@keyframes revealInLeft {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0%);
  }
}

@keyframes revealInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0%);
  }
}

@keyframes revealInTop {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0%);
  }
}

@keyframes revealInBottom {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0%);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeInLeft {
  from {
    transform: translateX(-20px);
    opacity: 0;
  }
  to {
    transform: translateX(0px);
    opacity: 1;
  }
}

@keyframes fadeInBottom {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0px);
    opacity: 1;
  }
}

@keyframes fadeOutBottom {
  from {
    transform: translateY(0px);
    opacity: 0;
  }
  to {
    transform: translateY(-20px);
    opacity: 1;
  }
}

@keyframes kenBurns {
  from {
    transform:scale3d(1,1,1) ;
    opacity:0;
  }
  2% {
    opacity:1;
  }
  98% {
    opacity:1;
  }
  to {
    transform:scale3d(1.2,1.2,1.2) ;
    opacity:0;
  }
}
</style>
